module.exports = "/images/vendor/flag-icon-css/flags/4x3/lb.svg?e33a49a9a071a76dd393f2928ce0f808";